import { LookbackOption, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { TradeTabProps } from '../../../types/LayoutConfig';
import { DEFAULT_TRADE_COLUMNS } from './columns';
import { MultilegView } from './useTradeFilter';

export const RECENT_TRADES_TAB_ID = 'recent-trades';

export const DEFAULT_TRADE_TABS: PersistedDefaultTabProps<TradeTabProps>[] = [
  {
    label: 'Recent',
    id: 'recent-trades',
    closable: false,
    editable: false,
    defaultFilter: {
      _start: LookbackOption.Past24Hours,
      MultilegView: MultilegView.Both,
    },
    defaultColumns: DEFAULT_TRADE_COLUMNS,
  },
];

export const NEW_TRADE_TAB_DEFAULTS = {
  defaultFilter: {
    _start: LookbackOption.Past24Hours,
    MultilegView: MultilegView.Both,
  },
  defaultColumns: DEFAULT_TRADE_COLUMNS,
} as const;

export const TRADE_TABS_EXCLUDED_IDS = DEFAULT_TRADE_TABS.map(tab => tab.id ?? '');
